import { DynamicIcon } from 'phosphor-icons/react';
import c from '../../../utils/tailwind-merge';
import { IconButtonProps } from './IconButton.types';

/**
 * Buttons that consist of only an Icon
 */
export const IconButton = ({
  iconName,
  ariaLabel,
  ariaLabelledby,
  className = '',
  iconClassName = '',
  iconSize,
  iconWeight = 'regular',
  testId,
  ...props
}: IconButtonProps) => {
  return (
    <button
      type="button"
      aria-label={ariaLabel}
      aria-labelledby={ariaLabelledby}
      className={c(
        'focus-outline flex w-6 items-center justify-center rounded',
        className
      )}
      data-test={testId}
      {...props}
    >
      <DynamicIcon
        iconName={iconName}
        size={iconSize}
        weight={iconWeight}
        aria-hidden="true"
        focusable="false"
        className={c(
          'fill-grey-400 transition-colors hover:fill-blue',
          { 'h-full w-full': !iconSize },
          iconClassName
        )}
      />
    </button>
  );
};
